import CustomZObject from './CustomZObject.js';

export default class DPad extends CustomZObject {
    constructor(zobject) {
        super(zobject);

        this.newOutlet("up");
        this.newOutlet("down");
        this.newOutlet("right");
        this.newOutlet("left");
        this.newOutlet("A");
        this.newOutlet("B");
    }
}
